export enum EditISFPTab {
  ISFPData = 'isfp-data',
  CostsAndPrices = 'costs-and-prices',
  Funding = 'funding',
}

export interface EditISFPTabToggleProps {
  selectedTab: EditISFPTab
  onTabChange: (tab: EditISFPTab) => void
}
